import React, { Component } from 'react';

export default class About extends Component {




  render() {
    return (
      <div className='section'>
        <h1 className='heading'>About me</h1>
        <p>Following my love for technology that began in my early years, playing around on a Commodore 64/128, getting excited over changing the
            background colour of the computer screen. As I grew, so did my curiosity, I began playing with
            games creating mods, creating simple web pages, and even making simple games using tools such as Unity.
            Now, having the opportunity of turning that inquisitive nature into a career, learning as much as
            possible along the way, I am embracing the future with an open mind, ready to tackle any challenge
            that comes my way.
</p>
      </div>
    )
  }
}